import { PageRender } from 'components/PageRender'
import { useUserSegmentation } from 'hooks/useUserSegmentation'
import { openDeeplink } from 'utils/helpers'
import * as S from 'pages/Support/styles'

type UsBranchSupportTemplateProps = {
  dictionary:
    | Record<string, string>
    | {
        relationshipCenterTitle: string
        relationshipCenterDescription: string
        relationshipCenterBrasilContact: string
        relationshipCenterBrasilContactDeepLink: string
        relationshipCenterBrasilContactInfo: string
        relationshipCenterOtherLocationsContact: string
        relationshipCenterOtherLocationsContactDeepLink: string
        relationshipCenterOtherLocationsContactInfo: string
        emailTitle: string
        emailContact: string
        emailContactDeepLink: string
      }
}

export const UsBranchSupportTemplate = ({ dictionary }: UsBranchSupportTemplateProps) => {
  const { userSegmentation, pageStatus } = useUserSegmentation()
  return (
    <PageRender pageStatus={pageStatus}>
      <S.SupportContainer>
        <S.SupportCard>
          <S.SupportTitle>{dictionary.relationshipCenterTitle}</S.SupportTitle>
          <S.SupportInfo>{dictionary.relationshipCenterDescription}</S.SupportInfo>
          <S.ContactContainer>
            <S.Contact
              onClick={() =>
                openDeeplink(
                  dictionary.relationshipCenterBrasilContactDeepLink,
                  dictionary.relationshipCenterTitle,
                  userSegmentation,
                )
              }
            >
              {dictionary.relationshipCenterBrasilContact}
            </S.Contact>
            <S.ContactInfo>{dictionary.relationshipCenterBrasilContactInfo}</S.ContactInfo>
          </S.ContactContainer>
          <S.ContactContainer>
            <S.Contact
              onClick={() =>
                openDeeplink(
                  dictionary.relationshipCenterOtherLocationsContactDeepLink,
                  dictionary.relationshipCenterTitle,
                  userSegmentation,
                )
              }
            >
              {dictionary.relationshipCenterOtherLocationsContact}
            </S.Contact>
            <S.ContactInfo>{dictionary.relationshipCenterOtherLocationsContactInfo}</S.ContactInfo>
          </S.ContactContainer>
        </S.SupportCard>
        <S.SupportCard>
          <S.SupportTitle>{dictionary.emailTitle}</S.SupportTitle>
          <S.ContactContainer>
            <S.Contact
              onClick={() =>
                openDeeplink(
                  dictionary.emailContactDeepLink,
                  dictionary.emailTitle,
                  userSegmentation,
                )
              }
            >
              {dictionary.emailContact}
            </S.Contact>
          </S.ContactContainer>
        </S.SupportCard>
      </S.SupportContainer>
    </PageRender>
  )
}
